import * as React from 'react';

import { StepsPanel } from '../StepsPanel';
import { Alert, AlertStatus } from '../Alert';
import { Finish } from '../TitleBadge/TitleBadge.types';

interface FinishSelectionProps {
    step: number;
    isSilverColor: boolean;
    isBronzeColor: boolean;
    isGoldColor: boolean;
    onChange: (finish: string) => void;
    finish: Finish;
}
export const FinishSelection = ({
    step,
    isSilverColor,
    isBronzeColor,
    isGoldColor,
    onChange,
    finish,
}: FinishSelectionProps) => {
    return (
        <StepsPanel
            title="Choose your finish"
            step={step}
        >
            {!isSilverColor && !isBronzeColor && (
                <label
                    className="finish-option"
                >
                    <input 
                        type="radio" 
                        id={Finish.Gold.toLowerCase()} 
                        name="finish" 
                        value={Finish.Gold}
                        onChange={() => onChange(Finish.Gold)}
                        checked={finish === Finish.Gold || isGoldColor}
                    />
                    Gold
                </label>
            )}
            {!isGoldColor && !isBronzeColor && (
                <label
                    className="finish-option"
                >
                    <input 
                        type="radio" 
                        id={Finish.Silver.toLowerCase()} 
                        name="finish" 
                        value={Finish.Silver}
                        onChange={() => onChange(Finish.Silver)}
                        checked={finish === Finish.Silver || isSilverColor}
                    />
                    Silver
                </label>
            )}
            {isBronzeColor && (
                <label
                    className="finish-option"
                >
                    <input 
                        type="radio" 
                        id={Finish.Bronze.toLowerCase()} 
                        name="finish" 
                        value={Finish.Bronze}
                        onChange={() => onChange(Finish.Silver)}
                        checked={finish === Finish.Bronze || isBronzeColor}
                    />
                    Bronze
                </label>
            )}
            
            {finish !== Finish.Gold && (
                <>
                    <Alert status={AlertStatus.Warning}>
                        Please note that we do not hold stock of Silver or Bronze badges. There will be a 3 week delivery time
                    </Alert>
                    <input 
                        type="hidden" 
                        id="custom-comments" 
                        name="properties[Comments]" 
                        value={`${finish} finish`}
                    />
                </>
            )}
        </StepsPanel>
    )
};